import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserRequestService } from '../../data-access/requests.service';

@Component({
    selector: 'app-newrequest',
    templateUrl: './newrequest.component.html',
    styleUrls: ['./newrequest.component.scss'],
    standalone: false
})
export class NewRequestComponent implements OnInit {
  @Input() prfyear: number;
  @Input() groupcode: string;
  @Input() custname: string;
  @Input() prfuser: string;

  requestForm: FormGroup;
  requestTypes: string[] = ['Unlock', 'Prior Year Copy'];
  isLoading: boolean = false;
  errorMessage: string | null = null;

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private requestService: UserRequestService
  ) { }

  ngOnInit(): void {
    this.requestForm = this.fb.group({
      requesttype: ['', Validators.required],
      prfnumber: [
        this.groupcode,
        [
          Validators.required,
          Validators.pattern(new RegExp(`^${this.groupcode}.*$`)),
        ],
      ],
      comment: ['', Validators.required],
      prfyear: [this.prfyear],
      groupcode: [this.groupcode],
      custname: [this.custname],
      prfuser: [this.prfuser],
    });
  }

  onsubmit(): void {
    if (this.requestForm.valid) {
      this.isLoading = true;
      this.errorMessage = null;
      this.requestService.postUserRequest(this.requestForm.value).subscribe({
        next: (response: { status: string; message?: string }) => {
          if (response.message !== 'Success') {
            this.errorMessage = response.message || 'Error creating request. Please try again.';
            this.isLoading = false;
          } else {
            this.activeModal.close(true);
          }
        },
        error: (error) => {
          this.errorMessage = error.error.message || 'Error creating request. Please try again.';
          this.isLoading = false;
        },
      });
    }
  }
}
